import React, { useEffect } from 'react';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { API_BASE_URL } from '../../api-base-url';
import { Festivals } from '../festivals';
import { Performers } from '../performers';
import { SectionNavbar } from '../section-navbar';
import { Vendors } from '../vendors';

export default function Home() {
  const clearFestivalWorkspace = useFestivalWorkspaceStore(
    (s) => s.clearFestivalWorkspace,
  );

  useEffect(() => {
    clearFestivalWorkspace();
  }, [clearFestivalWorkspace]);

  /** Labels match BeThere `event-mgt.html` tab nav: My Events / My Vendors / My Performers */
  const sections = [
    {
      title: 'My Events',
      component: <Festivals />,
    },
    {
      title: 'My Vendors',
      component: <Vendors />,
    },
    {
      title: 'My Performers',
      component: <Performers />,
    },
  ];

  const showBuildInfo = import.meta.env.MODE === 'development';
  const deployDate = import.meta.env.VITE_DEPLOY_DATE;

  return (
    <div className="flex min-h-full flex-col">
      <SectionNavbar navItems={sections} />
      {showBuildInfo && (deployDate || API_BASE_URL) && (
        <div className="mt-auto px-4 py-8 text-center text-sm text-[var(--muted-foreground)] md:px-6">
          {deployDate && <div>Deploy date: {deployDate}</div>}
          {API_BASE_URL && <div>API URL: {API_BASE_URL}</div>}
        </div>
      )}
    </div>
  );
}
